import { withNaming } from '@bem-react/classname';

export const createClassName = withNaming({ e: '__', m: '--', v: '_' });
